import {
    MaterialValidationMessages,
    validateMaterialName,
    validateMaterialAvailability,
    normalizeAvailabilityForForm,
    availabilityToPayload
} from '../enums';
import { isValidHttpUrl } from '@features/uploadAsset';
import { t } from '@i18n';

/**
 * Data Transfer Object for creating a material (URLs for files — no base64).
 */
export class CreateMaterialDTO {
    constructor({
        community,
        name,
        availability,
        path,
        banner,
        allow_download
    }) {
        this.community = parseInt(community, 10);
        this.name = name?.trim();
        this.availability = normalizeAvailabilityForForm(availability);
        this.path = path;
        this.banner = banner && isValidHttpUrl(banner) ? banner : undefined;
        this.allow_download = allow_download !== false;
    }

    /**
     * @returns {{valid: boolean, error?: string}}
     */
    validate() {
        if (!this.community || isNaN(this.community)) {
            return {
                valid: false,
                error: MaterialValidationMessages.COMMUNITY_INVALID
            };
        }

        const nameValidation = validateMaterialName(this.name);
        if (!nameValidation.valid) {
            return nameValidation;
        }

        if (!isValidHttpUrl(this.path)) {
            return {
                valid: false,
                error: MaterialValidationMessages.MATERIAL_REQUIRED
            };
        }

        const availabilityValidation = validateMaterialAvailability(this.availability);
        if (!availabilityValidation.valid) {
            return availabilityValidation;
        }

        if (this.banner != null && this.banner !== '' && !isValidHttpUrl(this.banner)) {
            return {
                valid: false,
                error: t('contentModals:manageMaterial.errors.invalidBannerUrl')
            };
        }

        return { valid: true };
    }

    /**
     * @returns {Object}
     */
    toPayload() {
        const payload = {
            community: this.community,
            name: this.name,
            path: this.path,
            availability: availabilityToPayload(this.availability),
            allow_download: this.allow_download
        };

        if (this.banner) {
            payload.banner = this.banner;
        }

        return payload;
    }
}
